// extracted by mini-css-extract-plugin
export var dividerLine = "_5c-0";
export var errorBackground = "_5c-1";